import { useState, useEffect } from 'react'
import { useStore, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import _ from 'lodash'

import { Card } from '@mui/material'

import { ListDisplay } from '../../ListDisplay/ListDisplay'

import { constants } from '../../../Constants/constants'
import { getList, getOne } from '../../../helper/baseFetch'
import { getParamQueryString, getQuery, getQueryParamObject } from '../../../helper/util'

export const ProductExistingRedeemGroupList = ({
  newFilter,
  editBtn,
  createBtn,
  mutipleSelect,
  setPreviewSelectedList,
  previewSelectedList,
  selectedIdList,
  setSelectedIdList,
  dialogFooterBtn,
  onClickListRow,
  changeUrlQueryString,
}) => {
  const store = useStore()
  const [redeemGroupList, setProductExistingRedeemGroupList] = useState([])
  const [ready, setReady] = useState(false)
  const total = useSelector((state) => state.system.ui.total)
  const [selectedAllCheck, setSelectedAllCheck] = useState(false)
  const resource = 'productCreateRedeemGroupList'
  const history = useHistory()
  const location = useLocation()
  const filterParams = getQuery()

  const redeemGroupTitleList = [
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: 'redeemGroupCode',
      sort: true,
    },
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: 'codeDescription',
      sort: true,
    },
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: 'status',
      sort: true,
    },
  ]
  const listFilters = [
    {
      className: "filter-input",
      label: { resource: resource, key: "redeemGroupCode" },
      clear: true,
      value: '',
      name: 'redeemGroupCode',
      size: constants.SIZE.SMALL,
    },
    {
      className: "filter-input",
      label: { resource: resource, key: "codeDescription" },
      clear: true,
      value: '',
      name: 'codeDescription',
      size: constants.SIZE.SMALL,
    },
  ]

  const [param, setParam] = useState(
    !changeUrlQueryString
      ? {
          path: '',
          page: 0,
          rowsPerPage: 10,
          sort: 'updateTimestamp',
          direction: 'DESC',
          listFilters: _.cloneDeep(listFilters),
          count: 0,
        }
      : getQueryParamObject(
          {
            path: '',
            page: 0,
            rowsPerPage: 10,
            sort: 'updateTimestamp',
            direction: 'DESC',
            listFilters: _.cloneDeep(listFilters),
            count: 0,
          },
          _.cloneDeep(listFilters),
          redeemGroupTitleList
        )
  )

  useEffect(() => {
    if (!changeUrlQueryString) {
      return
    }

    const querySyring = getParamQueryString(
      {
        path: '',
        page: 0,
        rowsPerPage: 10,
        sort: 'updateTimestamp',
        direction: 'DESC',
        listFilters: _.cloneDeep(listFilters),
        count: param.count,
      },
      param
    )

    const currentQueryString = window.location.search?.substring(1)

    if (querySyring === currentQueryString) {
      return
    }

    const newParam = getQueryParamObject(
      {
        path: '',
        page: 0,
        rowsPerPage: 10,
        sort: 'updateTimestamp',
        direction: 'DESC',
        listFilters: _.cloneDeep(listFilters),
        count: param.count + 1,
      },
      _.cloneDeep(listFilters),
      redeemGroupTitleList
    )

    setParam(newParam)

    const newQuery = getParamQueryString(
      {
        path: '',
        page: 0,
        rowsPerPage: 10,
        sort: 'updateTimestamp',
        direction: 'DESC',
        listFilters: _.cloneDeep(listFilters),
        count: 0,
      },
      newParam
    )

    history.replace({ pathname: location.pathname, search: newQuery })
  }, [filterParams])

  function onChangeParam(value) {
    value.count = value.count + 1

    if (!changeUrlQueryString) {
      setParam(value)
      return
    }

    const querySyring = getParamQueryString(
      {
        path: '',
        page: 0,
        rowsPerPage: 10,
        sort: 'updateTimestamp',
        direction: 'DESC',
        listFilters: _.cloneDeep(listFilters),
        count: 0,
      },
      value
    )

    history.push({ pathname: location.pathname, search: querySyring })
  }

  function onChangeListFilters(list) {
    let tempParam = _.cloneDeep(param)
    tempParam.listFilters = list
    tempParam.page = 0
    onChangeParam(tempParam)
  }

  function onChangeListSort(sortItem) {
    let tempParam = _.cloneDeep(param)
    tempParam.sort = sortItem
    tempParam.direction = tempParam.direction === 'DESC' ? 'ASC' : 'DESC'
    onChangeParam(tempParam)
  }

  function onChangeListPage(page) {
    let tempParam = _.cloneDeep(param)
    tempParam.page = page
    onChangeParam(tempParam)
  }

  function onChangeListRowsPerPage(rowsPerPage) {
    let tempParam = _.cloneDeep(param)
    tempParam.page = 0
    tempParam.rowsPerPage = rowsPerPage
    onChangeParam(tempParam)
  }

  function onMultiSelectList(id, dataList) {
    let selectedList = selectedIdList ? _.cloneDeep(selectedIdList) : []
    let newSelectedProductExistingRedeemGroupList = _.cloneDeep(previewSelectedList)
    if (id === 'all') {
      if (!selectedAllCheck) {
        redeemGroupList.map((item) => {
          let selected = newSelectedProductExistingRedeemGroupList
            .map((item) => {
              return item.id
            })
            .includes(item.id)
          if (!selected) {
            newSelectedProductExistingRedeemGroupList.push(item)
          }
          return !selected && selectedList.push(item.id)
        })
      } else {
        selectedList = selectedList.filter((item) => {
          let selectedProductExistingRedeemGroup = redeemGroupList.map((redeemGroup) => {
            newSelectedProductExistingRedeemGroupList = newSelectedProductExistingRedeemGroupList.filter(
              (newSelectedProductExistingRedeemGroup) => newSelectedProductExistingRedeemGroup.id !== redeemGroup.id
            )
            return redeemGroup.id === item && redeemGroup.id
          })
          return !selectedProductExistingRedeemGroup.includes(item)
        })
      }
      setSelectedAllCheck(!selectedAllCheck)
    } else {
      if (selectedList.includes(id)) {
        selectedList = selectedList.filter((item) => item !== id)
        newSelectedProductExistingRedeemGroupList = newSelectedProductExistingRedeemGroupList.filter((item) => item.id !== id)
      } else {
        selectedList.push(id)
        newSelectedProductExistingRedeemGroupList.push.apply(
          newSelectedProductExistingRedeemGroupList,
          dataList.filter((item) => item.id === id)
        )
      }

      let selectedPerPage = redeemGroupList.filter((redeemGroup) => {
        return selectedList.includes(redeemGroup.id)
      })
      if (selectedPerPage.length === param.rowsPerPage && selectedPerPage.length !== 0) {
        setSelectedAllCheck(true)
      } else {
        setSelectedAllCheck(false)
      }
    }

    setSelectedIdList(selectedList)

    setPreviewSelectedList(newSelectedProductExistingRedeemGroupList)
  }

  useEffect(() => {
    let tempParam = _.cloneDeep(param)
    const filter = newFilter ? _.cloneDeep(newFilter) : {}
    tempParam.listFilters.forEach((filterItem) => {
      if (filterItem.value !== '' && filterItem.value !== undefined) {
        filter[filterItem.name] = filterItem.value
      }
    })

    getList(
      constants.PATH.PRODUCT.REDEEM_GROUP,
      {
        sort: { field: tempParam.sort, order: tempParam.direction },
        filter: filter,
        pagination: { page: tempParam.page + 1, perPage: tempParam.rowsPerPage },
      },
      (payload) => {
        setProductExistingRedeemGroupList(payload)
        let selectedPerPage = payload.filter((queueTemplate) => {
          return (
            selectedIdList &&
            selectedIdList
              .map((selectedId) => {
                return selectedId
              })
              .includes(queueTemplate.id)
          )
        })
        if (selectedPerPage.length === Number(tempParam.rowsPerPage < total ? tempParam.rowsPerPage : total) && selectedPerPage.length !== 0) {
          setSelectedAllCheck(true)
        } else {
          setSelectedAllCheck(false)
        }
        setReady(true)
      },
      undefined,
      store
    )
  }, [param.count]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    ready && (
      <Card className="card-wrapper overflow">
        <ListDisplay
          onClickListRow={onClickListRow}
          page={param.page}
          rowsPerPage={param.rowsPerPage}
          onChangeListSort={onChangeListSort}
          resource={resource}
          dataList={redeemGroupList}
          idName="id"
          sort={param.sort}
          direction={param.direction}
          listTitles={redeemGroupTitleList}
          listFilters={param.listFilters}
          onChangeListPage={onChangeListPage}
          onChangeListRowsPerPage={onChangeListRowsPerPage}
          onChangeListFilters={onChangeListFilters}
          editBtn={editBtn}
          createBtn={false}
          mutipleSelect={mutipleSelect}
          onMultiSelectList={onMultiSelectList}
          selectedAllCheck={selectedAllCheck}
          previewSelectedIdList={selectedIdList}
          dialogFooterBtn={dialogFooterBtn}
          redirectPath={'/' + constants.PATH.PRODUCT.REDEEM_GROUP + '/'}
        />
      </Card>
    )
  )
}

export const getRedeemGroup = (redeemId, store) => {
  return new Promise((resolve, reject) => {
    getOne(
      constants.PATH.PRODUCT.REDEEM_GROUP + '/' + redeemId,
      undefined,
      (payload) => {
        resolve(payload)
      },
      undefined,
      store
    )
  })
}
